
import FiltroPeriodo from "./FiltroPeriodo.vue";

export default {
  name: "TicketMedio",
  components: { FiltroPeriodo },
  props: {
    ticketMedio: { type: [Number, String], default: 0 },
    loading: { type: Boolean, default: false },
    error: { type: String, default: null },

    // { inicio: 'YYYY-MM-DD', fim: 'YYYY-MM-DD' }
    periodo: {
      type: Object,
      default: () => ({ inicio: null, fim: null }),
    },

    // ignora o primeiro @apply disparado pelo FiltroPeriodo no mount
    ignoreInitialApply: { type: Boolean, default: true },
  },

  data() {
    return {
      // eslint-disable-next-line vue/no-reserved-keys
      _booting: true, // flag de boot para ignorar 1º apply automático
    };
  },

  mounted() {
    // depois do primeiro frame, consideramos que terminou o boot
    this.$nextTick(() => {
      this._booting = false;
    });
  },

  computed: {
    ticketMedioNumber() {
      const n = Number(this.ticketMedio);
      return Number.isFinite(n) ? n : 0;
    },
  },

  methods: {
    onApplyPeriodo({ inicio, fim }) {
      // 1) ignora apply automático do filtro no mount
      if (this._booting && this.ignoreInitialApply) return;

      // 2) evita emitir se vier incompleto
      if (!inicio || !fim) return;

      // 3) evita emitir se não houve mudança real
      const same =
        this.periodo &&
        this.periodo.inicio === inicio &&
        this.periodo.fim === fim;

      if (same) return;

      // 4) agora sim, emite pro pai buscar apenas o ticket médio
      this.$emit("change-periodo", { inicio, fim });
    },

    formatCurrency(v) {
      try {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(v ?? 0);
      } catch {
        const num = Number(v ?? 0)
          .toFixed(2)
          .replace(".", ",");
        return `R$ ${num}`;
      }
    },

    formatRange(inicio, fim) {
      const fmt = (s) => {
        const [y, m, d] = (s || "").split("-").map(Number);
        return new Date(y || 0, (m || 1) - 1, d || 1).toLocaleDateString(
          "pt-BR"
        );
      };
      return `${fmt(inicio)} à ${fmt(fim)}`;
    },
  },
};
